















import {Vue, Component, Prop} from "vue-property-decorator";
import FscSimpleCard from "@/components/Card/FscSimpleCard.vue";

@Component({
  components: {
    FscSimpleCard,
  },
})
export default class KiPilotTheorieFunctionCard extends Vue {
  public name = "KiPilotTheorieFunctionCard";

  @Prop({type: String, required: true})
  public title!: string;

  @Prop({type: String, required: true})
  public description!: string;

  @Prop({type: Boolean, default: () => false})
  public loading!: boolean;

  @Prop({type: Boolean, default: () => false})
  public disabled!: boolean;

  @Prop({type: Boolean, default: () => false})
  public active!: boolean;

  private onClick(): void {
    if (this.loading || this.disabled) return;
    this.$emit("start");
  }
}
